import { create } from 'zustand';

interface AuthUser {
  id: string;
  email: string;
  name: string;
  avatar?: string;
  tier: 'FREE' | 'PRO';
  role: 'USER' | 'ADMIN';
}

interface AuthState {
  user: AuthUser | null;
  isLoading: boolean;
  setUser: (user: AuthUser | null) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  setUser: (user) => set({ user, isLoading: false }),
  clearUser: () => set({ user: null, isLoading: false }),
}));
